import React from 'react'
import style from "./style/Main.module.css"
import img from "../img/phlushkov.jpg"
import cv from "../CV/PHlushkovCv.pdf"

function Main() {
    return (
        <main>
            <div className={style.main__body}>
                <div className={style.main__info}>
                    <h2 className={style.main__h2}>Hi, I am Hlushkov Pavlo</h2>
                    <p className={style.main__p}>Frontend Developer</p>
                    <div className={style.main__btn}>
                        <button ><a className={style.btn_cv} href={cv} download>Download CV</a></button>
                        <button><a target='_blank' href="https://t.me/P_Hlushkov" className={style.btn_writeMe}>Write me</a></button>
                    </div>
                </div>
                <div className={style.main__img}>
                    <div className={style.imgContainer}>
                       <img className={style.img} src={img} alt="PHlushkov" />
                    </div>
                </div>
            </div>
        </main>
    )
}

export default Main